var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_789_21247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2255 15.3838V22.2232C23.2255 22.7659 22.7841 23.2073 22.2414 23.2073H2.95325C2.41062 23.2073 1.96916 22.7659 1.96916 22.2232V15.3838H0.000976562V22.2232C0.000976562 23.8511 1.32537 25.1755 2.95325 25.1755H22.2414C23.8693 25.1755 25.1937 23.8511 25.1937 22.2232V15.3838H23.2255Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5966 17.5449L18.7119 11.4296L17.3202 10.0379L13.5807 13.7774L13.5807 2.6992L11.6125 2.6992L11.6125 13.7774L7.87294 10.0379L6.48123 11.4296L12.5966 17.5449Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_789_21247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1927,
    height: 25.1927,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.b2420cba819750e0add891414cde79ee.svg";
export { ForwardRef as ReactComponent };